var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "language-settings" }, [
    _c(
      "ul",
      { staticClass: "list-unstyled" },
      [
        _vm._l(_vm.languageList, function (language) {
          return [
            _c("li", { class: { active: language === _vm.currentLanguage } }, [
              _c(
                "a",
                {
                  staticClass: "language-settings__link",
                  attrs: { href: _vm.generateUrl(language, false) },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.changeLanguage(
                        $event,
                        _vm.generateUrl(language, true),
                        language
                      )
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "flag-icon",
                      attrs: { xmlns: "http://www.w3.org/2000/svg" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#" + language,
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$translate(
                          "Ceres::Template.header" + _vm.capitalize(language)
                        )
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }